module.exports = __webpack_public_path__ + "img/line.f5cdd15f.svg";